import {Tag} from '@wandb/weave/components/Tag/Tag';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {useIssuesContext} from '../../state/issues/IssuesContext';
import {WBTableRowWithRunSetInfo} from '../../util/tablecols';
import {Skeleton} from '../Skeleton';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawer/WorkspaceDrawerContextProvider';
import {useRunIssues} from './hooks/useRunIssues';

type RunSelectorIssuesCellProps = {
  row: WBTableRowWithRunSetInfo;
  entityName: string;
  projectName: string;
};

export function RunSelectorIssuesCell({
  row,
  entityName,
  projectName,
}: RunSelectorIssuesCellProps) {
  const {toggleWorkspaceDrawer} = useWorkspaceDrawerContext();
  const {addIssues} = useIssuesContext();

  const {data: nodeAlertsHistory, loading} = useRunIssues({
    entityName,
    projectName,
    runName: row.name,
  });

  if (loading) {
    return (
      <TailwindContents>
        <Skeleton className="rounded-sm opacity-60" height={22} width={35} />
      </TailwindContents>
    );
  }
  if (!nodeAlertsHistory.length) {
    return null;
  }

  function handleClick() {
    toggleWorkspaceDrawer('run-issues');
    addIssues(nodeAlertsHistory); // Convert to internal type?
  }

  // FIXME: Use @wandb/components when that becomes available:
  return (
    <TailwindContents>
      <div onClick={handleClick} className="cursor-pointer">
        <Tag
          showIcon
          iconName="warning"
          label={String(nodeAlertsHistory.length)}
          color="red"
        />
      </div>
    </TailwindContents>
  );
}
